var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinCheckCicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99916 22.5716C14.733 22.5716 18.5706 18.734 18.5706 14.0001C18.5706 9.26627 14.733 5.42871 9.99916 5.42871C5.26529 5.42871 1.42773 9.26627 1.42773 14.0001C1.42773 18.734 5.26529 22.5716 9.99916 22.5716ZM9.99916 21.4287C5.89648 21.4287 2.57059 18.1028 2.57059 14.0001C2.57059 9.89745 5.89648 6.57157 9.99916 6.57157C14.1019 6.57157 17.4277 9.89745 17.4277 14.0001C17.4277 18.1028 14.1019 21.4287 9.99916 21.4287ZM6.16653 13.5961C6.38969 13.3729 6.7515 13.3729 6.97465 13.5961L8.85631 15.4777L13.0237 11.3104C13.2468 11.0872 13.6086 11.0872 13.8318 11.3104C14.055 11.5335 14.055 11.8953 13.8318 12.1185L9.30077 16.6495C9.0553 16.895 8.65731 16.895 8.41184 16.6495L6.16653 14.4042C5.94337 14.181 5.94337 13.8192 6.16653 13.5961Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinCheckCicleIcon);
export default __webpack_public_path__ + "static/media/zeppelin-check-cicle-icon.d267943b.svg";
export { ForwardRef as ReactComponent };